/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Export_Power_Point_Actions_ExportInputs */

const en_export_power_point_actions_export = /** @type {(inputs: Export_Power_Point_Actions_ExportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Export`)
};

const de_export_power_point_actions_export = /** @type {(inputs: Export_Power_Point_Actions_ExportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportieren`)
};

/**
* | output |
* | --- |
* | "Export" |
*
* @param {Export_Power_Point_Actions_ExportInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const export_power_point_actions_export = /** @type {((inputs?: Export_Power_Point_Actions_ExportInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Export_Power_Point_Actions_ExportInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_export_power_point_actions_export(inputs)
	return de_export_power_point_actions_export(inputs)
});